import React, { RefObject, createRef, SyntheticEvent, ChangeEvent } from 'react';
import { compose } from 'react-apollo';
import { injectIntl } from 'react-intl';

interface Props {
    onUpload: (codes: string[]) => void;
}


class TxtCodeUploadButton extends React.Component<Props> {
    private fileInputRef: RefObject<HTMLInputElement> = createRef();

    private handleFile = (file: File, reader: any) => (e: any) => {
        const codes = reader.result.split("\n").filter((code: string) => !!code);
        if (codes) {
            this.props.onUpload(codes);
        }
    }

    private handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length) {
            const file = e.target.files[0];
            const reader = new FileReader();
            reader.onloadend = this.handleFile(file, reader);
            reader.readAsText(file);
        }
    }
    public render() {
        return (
            <div>
                <input type="file" hidden={true} style={{display: 'none'}} ref={this.fileInputRef} onChange={this.handleChange} accept="text/*" />

                <button className="btn btn-primary btn-block" onClick={(e: SyntheticEvent) => {
                        e.preventDefault();
                        this.fileInputRef.current!.click();
                    }}>TXT file feltöltése</button>
            </div>
        );
    }
}

export default compose(
    injectIntl,
)(TxtCodeUploadButton);



// WEBPACK FOOTER //
// ./src/modules/Coupon/components/TxtCodeUploadButton.tsx